<footer class="footerWrapper">
  <div class="container">
    <div class="_inner">
      <div class="_s1">
        <h5 class="">We are business people, just like you</h5>
        <p class="text-neutral-900 text-sm font-normal leading-normal">Discover comprehensive computer services designed to keep your business operating seamlessly. With our
          responsive on-call support, expect prompt on-site assistance—same day or next business day—ensuring your computer issues are identified and resolved efficiently and
          professionally. <br /><a href="javascript:void(0);" class="text-active-600">Read More</a></p>
      </div>
      <div class="_s2">
        <div class="grid grid-cols-2 gap-5">
          <div class="col-start-1 col-span-1">
            <h5 class="">Services</h5>
            <ul>
              <li>
                <a href="javascript:void(0);" [routerLink]="['/services/residential']">Residential/Home</a>
              </li>
              <li>
                <a href="javascript:void(0);" [routerLink]="['/services/business']">Business/Corporate</a>
              </li>
              <li>
                <a href="javascript:void(0);" [routerLink]="['/services/mssp']">Managed Service Provider</a>
              </li>
              <li>
                <a href="javascript:void(0);" [routerLink]="['/services/cloud-backup']">Cloud Backup</a>
              </li>
            </ul>
          </div>
          <div class="col-span-1">
            <h5 class="">Company</h5>
            <ul>
              <li>
                <a href="javascript:void(0);" [routerLink]="['/about']">About Us</a>
              </li>
              <li>
                <a href="javascript:void(0);">Our Team</a>
              </li>
              <li>
                <a href="javascript:void(0);" [routerLink]="['/services/business']">Services</a>
              </li>
              <li>
                <a href="javascript:void(0);">Case Studies</a>
              </li>
              <li>
                <a href="javascript:void(0);">Careers</a>
              </li>
              <li>
                <a href="javascript:void(0);" [routerLink]="['/news']">Blog</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="_s3">
        <h5 class="">Get In Touch</h5>
        <ul>
          <li>
            37 Nepean Street Suite 203, Sydney, Nova Scotia
          </li>
          <li>
            <a href="mailto:info@chantsit.com">info&#64;chantsit.com</a>
          </li>
          <li>
            Mon-Fri 9:30 am to 5:30 pm AST
          </li>
          <li>
            Phone:1-902-578-4458<br>
            Toll-Free:1-866-515-4492
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="_footerMain">
    <div class="container">
      <div class="flex flex-wrap items-center justify-between gap-2 max-[500px]:justify-center">
        <p class="text-smoke-400 text-xs font-normal">Chant's IT Solutions © 2023.</p>
        <div class="flex flex-wrap items-center justify-between max-[670px]:w-full gap-5 max-[500px]:flex-col max-[500px]:gap-2">
          <ul class="inline-flex flex-wrap gap-3">
            <li>
              <a href="javascript:void(0);">Privacy Policy</a>
            </li>
            <li>
              <a href="javascript:void(0);">Terms of Service</a>
            </li>
            <li>
              <a href="javascript:void(0);">Cookies Settings</a>
            </li>
          </ul>
          <div class="_social">
            <a href="javascript:void(0);">
              <i-icon [name]="'linkedin'" [height]="'h-5'" [width]="'w-5'"></i-icon>
            </a>
            <a href="javascript:void(0);">
              <i-icon [name]="'facebook'" [height]="'h-5'" [width]="'w-5'"></i-icon>
            </a>
            <a href="javascript:void(0);">
              <i-icon [name]="'instagram'" [height]="'h-5'" [width]="'w-5'"></i-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>